//
// load facebook lib remote
//

export function loadLib() {
  (function(d, s, id) {
    let js = undefined;
    const fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) { return; }
    js = d.createElement(s);
    js.id = id;
    js.src = '//connect.facebook.net/en_US/sdk.js';
    fjs.parentNode.insertBefore(js, fjs);})(document, 'script', 'facebook-jssdk');
}

//
// FB show after share content
//

const fbShowAfterShareContent = () => document.querySelectorAll('.fb-share-score').forEach(score => score.style.display = "none");

//
// FB redirect user after share
//

const fbRedirectAfterShare = function(url) {
  if (url.match('//')) { return location.href = url; }

  location.href = location.protocol + '//' + location.host + url;
};

//
// FB share
//

const fbShare = function(App, AppEvents) {
  const $fbShareButton = $('.js-fb-share');

  if (!$fbShareButton.length) { return; }

  $fbShareButton.on('click', function(e) {
    e.preventDefault();
    const $this = $(e.currentTarget);

    const options = {
      method: 'share',
      href: $this.data('link'),
      display: 'popup'
    };

    const callback = function() {
      App.trigger(AppEvents.fbShareClosed);

      if (!!$this.data('hide-after')) {
        fbShowAfterShareContent();
      }

      if (!!$this.data('redirect-url')) {
        fbRedirectAfterShare($this.data('redirect-url'));
      }
    };

    FB.ui(options, callback);
  });
};


//
// FB async init
//

export function asyncInit(App, AppEvents) {
  const fbApiInfo = $('head').find('meta[property="fb:app_id"]');

  if (fbApiInfo.attr('content')) {
    window.fbAsyncInit = function() {
      FB.init({
        appId: fbApiInfo.attr('content'),
        version: 'v' + fbApiInfo.data('version'),
        xfbml: true
      });

      FB.AppEvents.logPageView();

      // tell the world that facebook loaded
      FB.getLoginStatus(function(response) {
        if (response.status === 'connected') {
          console.log('FB connected...');
          $(document).trigger(AppEvents.fbConnected, [response.authResponse]);
        }});

      // async pre-crawling via facebook so that facebook has the image
      const isOnCrawlPage = (window.location.href.match('/start') !== null) || (window.location.href.match('/complete') !== null);

      if ($('meta[property="og:title"]').attr('property') && isOnCrawlPage) {
        setTimeout((() => $.get(fbApiInfo.data('crawlUrl'), {url: window.location.href})), 2000);
      }

      // attach facebook related events
      fbShare(App, AppEvents);
    };
  }
}